import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export function useVignetteTargeting(disabledPaths = []) {
  const location = useLocation();

  useEffect(() => {
    if (window.googletag?.cmd) {
      window.googletag.cmd.push(() => {
        if (window.googletag.pubads) {
          handleVignetteTargeting();
        }
      });
    }
  }, []);

  useEffect(() => {
    if (window.googletag?.cmd) {
      window.googletag.cmd.push(() => handleVignetteTargeting());
    }
  }, [location.pathname, disabledPaths]);

  const handleVignetteTargeting = () => {
    const pathname = location.pathname;

    if (typeof window === 'undefined' || !window.googletag?.pubads) return;

    let shouldDisable = false

    disabledPaths.forEach(path => {
      if (pathname.startsWith(path)) {
        shouldDisable = true;
      }
    })

    const targeting = { displayvignette: `${!shouldDisable}` };

    if (typeof window.googletag.setConfig === 'function') {
      window.googletag.setConfig({ targeting });
    }
  }
}